const truncateProfileName = (name, maxLength = 20) => {
  if (!name) return '';
  if (name.length <= maxLength) return name;
  return name.substring(0, maxLength) + '...';
};
export default truncateProfileName;